module.exports = __webpack_public_path__ + "img/logo.2071c986.png";